import { Option } from "effect";

/**
 * KTD3: the captured LinkedIn fields ride in the `/capture` URL fragment. At
 * boot, before analytics or routing see the URL, the fragment moves into
 * session storage and the address bar becomes bare `/capture`. The page then
 * reads the stash through `readCapturePayload` (inside a Command: storage is
 * I/O, as `developerOptions` treats localStorage), never the URL.
 */

export const STORAGE_KEY = "capture-payload";

type Location = Readonly<{ pathname: string; hash: string }>;

export const stashCaptureFragment = (
	location: Location,
	storage: Pick<Storage, "setItem">,
	replaceUrl: (url: string) => void,
): void => {
	if (location.pathname !== "/capture" || location.hash.length < 2) return;
	try {
		storage.setItem(STORAGE_KEY, location.hash.slice(1));
	} catch {
		// Storage unavailable: the page reports the capture as unreadable (R4).
	}
	replaceUrl("/capture");
};

/** The stash stays for the window's life, so a page re-entry (for example, an org switch) still finds it. */
export const readCapturePayload = (
	storage: Pick<Storage, "getItem">,
): Option.Option<string> => {
	try {
		return Option.fromNullishOr(storage.getItem(STORAGE_KEY));
	} catch {
		return Option.none();
	}
};
